import { isDesktop } from "react-device-detect";
import { DesktopPage } from "./DesktopPage";
import { MobilePage } from "./MobilePage";
import { useEffect, useState } from "react";
import { useConfig } from "../../context/ConfigContext";
import { useTranslation } from "react-i18next";
import { CircularProgress } from "@mui/material";

export const WelcomePage = ({ onFinish }) => {
  const { t, i18n } = useTranslation(["homeModule"]);
  const { updatePartnerName } = useConfig();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    let customerName;

    customerName = params.get("u") || "1WJo7DGgiBf39pUIFhiPZLmgVAw2";
    let lng = params.get("lng") || "de";

    if (lng !== "de") {
      customerName = "zbJqq0MQmL4VShwSeKYisGU8AaO3";
      i18n.changeLanguage("en");
    } else {
      i18n.changeLanguage("de")
    }

    updatePartnerName(customerName).then(() => setIsLoading(false));
  }, []);

  return (
    <>
      {isLoading ? (
        <div className="home-loading-page">
          <CircularProgress
            disableShrink
            color="inherit"
            size={40}
            thickness={4}
          />
          <p className="loading-text">{t("initializing")}</p>
        </div>
      ) : isDesktop ? (
        <DesktopPage />
      ) : (
        <MobilePage onFinish={onFinish} />
      )}
    </>
  );
};
